import { BaseReactPlayerProps } from "react-player/base";

export const playerProps: BaseReactPlayerProps = {
  playing: true,
  loop: true,
  playsinline: true,
  controls: true,
  stopOnUnmount: true,
  width: "100%",
  height: "100%",
};
